const config = {
  apiUrl:
    window.location.hostname === "localhost"
      ? "http://localhost:4000/v1"
      : `${window.location.origin}/api/v1`,
  baseUrl:
    window.location.hostname === "localhost"
      ? "http://localhost:4000/"
      : `${window.location.origin}/`,
  nxmapBaseUrl: "https://nxmapglobal.evercomm.com.sg",
  nxplanBaseUr: "https://dev.nxplan.evercomm.io/",
  isStaging: window.location.hostname === "test.nxstart.evercomm.io",
};

export default config;
